









































import { Prop, Component, Vue } from "vue-property-decorator";
import "@/general/components/cms/css/cms-utility.scss";
import BlockContents from "@/general/components/cms/contents_type/BlockContents.vue";

// import HeaderFooter from "@/components/cms/contents_type/HeaderFooter";
import SpecialPage from "@/general/components/cms/contents_type/SpecialPage.vue";
// import OtherPage from "@/components/cms/contents_type/OtherPage.vue";
// import TopNewsImportant from "@/components/cms/view_type/TopNewsImportant.vue";
import TopNewsNormal from "@/general/components/cms/view_type/TopNewsNormal.vue";
// import NewsList from "@/components/cms/view_type/NewsList.vue";
// import News from "@/components/cms/contents_type/News.vue";

@Component({
  components: {
    BlockContents,
    // HeaderFooter,
    SpecialPage,
    // OtherPage,
    // TopNewsImportant,
    TopNewsNormal
    // NewsList,
    // News
  }
})
export default class CMS extends Vue {
  @Prop({ type: String, default: "" }) contents_type!: string;
  @Prop({ type: String, default: null }) location_code!: string;
  @Prop({ type: String, default: null }) view_type!: string;
  @Prop({ type: String, default: null }) view_area!: string;
  @Prop({ type: String, default: "" }) page_limit!: string;
  @Prop({ type: Array }) item_list!: [];
  @Prop({ type: Boolean, default: true }) show_more!: boolean;

  setTitle(title: string) {
    this.$emit("catchTitle", title);
  }
}
